import React from 'react';
import instagramIcon from '../assets/icons/instagramicon.svg';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        {/* Left side - Only sections, no brand */}
        <div className="footer-left">
          <div className="footer-sections">
            <div className="footer-section">
              <h4 className="footer-heading">Company</h4>
              <ul className="footer-links">
                <li><a href="https://quila.app/meet-the-team" className="footer-link" target="_blank" rel="noopener noreferrer">About Us</a></li>
              </ul>
            </div>

            <div className="footer-section">
              <h4 className="footer-heading">Support</h4>
              <ul className="footer-links">
                <li><a href="https://quila.app/contact-us" className="footer-link" target="_blank" rel="noopener noreferrer">Contact</a></li>
                <li><a href="https://quila.app/#faq" className="footer-link" target="_blank" rel="noopener noreferrer">FAQ</a></li>
              </ul>
            </div>

            <div className="footer-section">
              <h4 className="footer-heading">Legal</h4>
              <ul className="footer-links">
                <li><a href="https://quila.app/privacy-policy" className="footer-link" target="_blank" rel="noopener noreferrer">Privacy Policy</a></li>
                <li><a href="https://quila.app/terms-and-conditions" className="footer-link" target="_blank" rel="noopener noreferrer">Terms</a></li>
              </ul>
            </div>
          </div>
        </div>

        {/* Right side - Social media */}
        <div className="footer-right">
          <div className="social-links">
            <a 
              href="https://www.instagram.com/quila.app/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="social-link"
            >
              <img src={instagramIcon} alt="Instagram" />
            </a>
            <a 
              href="https://www.linkedin.com/company/quilaai/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="social-link"
            >
              <img src="/icons8-linkedin-50.png" alt="LinkedIn" />
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p className="footer-copyright">
          © {currentYear} Quila Incorporated. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer; 